module.exports = __webpack_public_path__ + "static/media/blog-12.79d71d03.svg";